export const fontFamily = {
    "code": "var(--fontFamilyCode)",
    "default": "var(--fontFamilyDefault)"
} as const;

export const text = {
    "body": {
        "bold": {
            "large": "var(--textBodyBoldLarge)",
            "medium": "var(--textBodyBoldMedium)",
            "small": "var(--textBodyBoldSmall)",
            "xSmall": "var(--textBodyBoldXSmall)"
        },
        "regular": {
            "large": "var(--textBodyRegularLarge)",
            "medium": "var(--textBodyRegularMedium)",
            "small": "var(--textBodyRegularSmall)",
            "xSmall": "var(--textBodyRegularXSmall)"
        }
    },
    "code": {
        "bold": {
            "large": "var(--textCodeBoldLarge)",
            "medium": "var(--textCodeBoldMedium)",
            "small": "var(--textCodeBoldSmall)",
            "xSmall": "var(--textCodeBoldXSmall)"
        },
        "regular": {
            "large": "var(--textCodeRegularLarge)",
            "medium": "var(--textCodeRegularMedium)",
            "small": "var(--textCodeRegularSmall)",
            "xSmall": "var(--textCodeRegularXSmall)"
        }
    },
    "heading": {
        "2xLarge": "var(--textHeading2xLarge)",
        "large": "var(--textHeadingLarge)",
        "medium": "var(--textHeadingMedium)",
        "small": "var(--textHeadingSmall)",
        "xLarge": "var(--textHeadingXLarge)",
        "xSmall": "var(--textHeadingXSmall)"
    }
} as const;